// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__Q2kkO","content":"Layout_content__COhUk"};